import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Selectable picker row (mockup `.pick`) — leading slot + title/subtitle + trailing slot.
 * Used by the vendor-switch modal, option lists, date pickers, etc.
 */
@Component({
  selector: 'app-pick-row',
  standalone: true,
  styleUrl: './pick-row.component.scss',
  imports: [CommonModule],
  templateUrl: './pick-row.component.html',
  
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PickRowComponent {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() selected = false;

  @Output() pick = new EventEmitter<void>();
}
